import React from 'react';

import { Apify } from '../Apify';
import Achievement from '../c/Achievement';
import { achievement_ids } from '../AchievementInfo';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { T } from '../traks';

var Achievements = (props) => {
	var earned_chieves_set = {};
	var n_earned = 0;
	for (const chieve of props.achievements) {
		earned_chieves_set[chieve] = true;
		n_earned++;
	}

	const n_total = achievement_ids.length;

	const cols = achievement_ids.map((id) => (
		<Col key={id} xs={12} sm={6} lg={4} xl={3} className="pb-4">
			<Achievement id={id} is_earned={!!earned_chieves_set[id]}/>
		</Col>
	));

	return (
		<Container>
			<Row className="pt-5">
				<Col>
					<div className="d-flex justify-content-between">
						<div>
							<h3><T>Achievements</T></h3>
						</div>
						<div className="d-flex justify-content-right">
							<h2>{n_earned}/{n_total}&nbsp;</h2>
							<span className="d-none d-md-inline-block pl-2 font-small ad_achievement_text"><T>Achievements can be won both<br/>in official and own games</T></span>
						</div>
					</div>
				</Col>
			</Row>
			<Row className="pt-5">
				{cols}
			</Row>
		</Container>
	);
}

Achievements = Apify("/z/user_achievements")
	.with_query_from_props(props => ({user_id: props.me.Id}))
	.with_response_prop("achievements")
	.wrap(Achievements);

export default connect(
	(state) => ({me: state.me})
)((props) => props.me && <Achievements me={props.me}/>);



// WEBPACK FOOTER //
// ./src/p/Achievements.js